import React from "react"
import theme from "./../../../Theme/Theme"
import { Div, Text, Row, Col } from "atomize";
import styled from "styled-components";
import trucateElipse from "../../../utils/truncateElipse";
import { Link } from "react-router-dom";
import ActivitiesIcon from "../ActivitiesIcon";
import Skeleton from 'react-loading-skeleton';

const Wrapper = styled(Div)`
  margin-bottom: 1rem;
  display: flex;
  @media (max-width: 450px ) {
    flex-direction: column;
  }
  
  transition: box-shadow .25s ease-in-out;
  
  &:hover {
    box-shadow: rgba(8, 11, 14, 0.06) 0px 0px 1px 0px, rgba(8, 11, 14, 0.1) 0px 16px 16px -1px;
    h3 {
      color: ${theme.colors.primary};	
    }
  }
`;

const Title = styled.h3`
  transition: color .25s ease-in-out;
  color: ${theme.colors.dark};	
  font-family: Inter;	
  font-size: 20px;	
  font-weight: 500;	
  line-height: 28px;
`;

const Description = styled.p`
  color: ${theme.colors.grayDark};	
  font-family: Inter;	
  font-size: 12px;	
  font-weight: 500;	
  line-height: 20px;
`;

const Type = styled.span`
  color: ${theme.colors.gray};	
  font-family: Inter;	
  font-size: 10px;	
  font-weight: 600;	
  letter-spacing: 1.2px;	
  line-height: 16px;
  text-transform: uppercase;
`;

const IconWrapper = styled.div`
  margin-right: 1.5rem;
  @media (max-width: 450px ) {
    margin-right: 1rem;
    
    svg {
      width: 40px;
      height: auto;
    }
  }
`;

const renderIcon = (type, color) => {
  return (
    <IconWrapper>
     <ActivitiesIcon
      type={type}
      color={color}
     />
    </IconWrapper>
  )
};

function ActivityCard(props) {
  const activity = props.activity;
  let regex = /(<([^>]+)>)/ig;
  let description = null;
  if (activity.body) {
    description = activity.body.value.replace(regex, "");
    description = trucateElipse(description, 120);
  }
  if (props.static) {
    return (
      <Wrapper
        shadow="3"
        p={'2rem'}
      >
        <Div>
          { activity.field_activity_type.name && activity.field_experience_layer.field_color.color && renderIcon(activity.field_activity_type.name, activity.field_experience_layer.field_color.color )}
        </Div>
        <Div>
          <Type>{activity.field_activity_type.name}</Type>
          <Title>{ activity.title }</Title>
          <Description> { description } </Description>
        </Div>
      </Wrapper>
    )
  } else {
    return (
      <Link
        to={ '/activities/' + encodeURIComponent(activity.title.toLowerCase())}
        className={'link'}
      >
        <Wrapper
          shadow="3"
          p={'2rem'}
        >
          <Div>
            {activity.field_activity_type.name && activity.field_experience_layer.field_color.color && renderIcon(activity.field_activity_type.name, activity.field_experience_layer.field_color.color)}
          </Div>
          <Div>
            <Type>{activity.field_activity_type.name}</Type>
            <Title>{activity.title}</Title>
            <Description> {description} </Description>
          </Div>
        </Wrapper>
      </Link>
    )
  }

}

function LoadingActivityCard() {
  return (
    <Wrapper
      shadow="3"
      p={'2rem'}
      style={{ display: 'block' }}
    >
      <Skeleton
        count={4}
      />
    </Wrapper>
  )
}

export { LoadingActivityCard };
export default ActivityCard;
